import React, { useState, useEffect } from "react";
import { Tab, Button, Icon } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListEvents,
  EventForm,
  EventCategoryManager,
  EventNavbar,
  CategoryForm,
} from "../../../components/Admin/Event";
import { Event } from "../../../api";
import { useAuth } from "../../../hooks";
import "./Events.scss";

const eventController = new Event();

export function Events() {
  const { accessToken } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    status: "",
    categoryId: "",
    targetAudience: "",
    search: "",
    orderBy: "eventDate",
  });

  const [selectedContent, setSelectedContent] = useState(null);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("eventsViewMode") || "grid"
  );

  const onOpenCloseModal = () => {
    setShowModal((prevState) => !prevState);
    setSelectedContent(null);
  };

  const onReload = () => setReload((prevState) => !prevState);

  const openEditModal = (data) => {
    setSelectedContent(data);
    setShowModal(true);
  };

  const handleTabChange = (e, { activeIndex }) => {
    setActiveTab(activeIndex);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await eventController.getEventCategories(accessToken);
        const options = response.data.map((cat) => ({
          key: cat.id,
          value: cat.id,
          text: cat.name,
        }));
        setCategories(options);
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    })();
  }, [accessToken, reload]);

  const panes = [
    {
      menuItem: "Eventos",
      render: () => (
        <Tab.Pane as="div" attached={false}>
          <EventNavbar
            filters={filters}
            setFilters={setFilters}
            setCurrentPage={setCurrentPage}
            categories={categories}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
          <ListEvents
            reload={reload}
            onReload={onReload}
            filters={filters}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            viewMode={viewMode}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Categorías",
      render: () => (
        <Tab.Pane as="div" attached={false}>
          <EventCategoryManager
            reload={reload}
            onReload={onReload}
            onEdit={openEditModal}
          />
        </Tab.Pane>
      ),
    },
  ];

  // Configuración del botón según el tab activo
  const buttonConfig = {
    0: { text: "Nuevo Evento", icon: "calendar plus" },
    1: { text: "Nueva Categoría", icon: "plus" },
  };

  return (
    <>
      <div className="admin-events-page">
        <div className="admin-events-page__header">
          <Button
            className="admin-events-page__add"
            primary
            onClick={onOpenCloseModal}
          >
            {activeTab !== 0 && <Icon name={buttonConfig[activeTab].icon} />}
            {buttonConfig[activeTab].text}
          </Button>
        </div>

        <Tab
          className="admin-events-page__filters"
          menu={{ secondary: true }}
          panes={panes}
          activeIndex={activeTab}
          onTabChange={handleTabChange}
        />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={
          activeTab === 0
            ? selectedContent
              ? "Editar Evento"
              : "Crear Evento"
            : selectedContent
            ? "Editar Categoría"
            : "Nueva Categoría"
        }
        size={activeTab === 0 ? "large" : "small"}
        scrolling={activeTab === 0}
      >
        {activeTab === 0 ? (
          <EventForm
            onClose={onOpenCloseModal}
            onReload={onReload}
            event={selectedContent}
          />
        ) : (
          <CategoryForm
            onClose={onOpenCloseModal}
            onReload={onReload}
            category={selectedContent}
          />
        )}
      </BasicModal>
    </>
  );
}
